// FEAT-29 — the attribute that marks the candidate's own-test fields as part
// of the code editor's work area (see `inCodeWorkArea` in ./index.ts).
//
// Its own dependency-free module on purpose: the component that renders the
// fields is also shown in Practice and in the recruiter's Preview, and must
// not pull the anti-cheat controller (camera, detectors) into those bundles.
export const OWN_TESTS_ATTR = "data-own-tests";
